import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Tag, Music, Fish, Mail, Zap } from 'lucide-react';
const games = [{
  id: 1,
  title: 'Wobblefish Chronicles',
  price: '€14.99',
  desc: 'A meditative fishing RPG where the fish philosophize about the nature of water.',
  icon: <Fish className="w-12 h-12" data-id="element-19" />,
  color: 'bg-brand-lime',
  rotate: 'rotate-1'
}, {
  id: 2,
  title: 'The Peculiar Postman',
  price: '€9.99',
  desc: 'Deliver letters in a town where gravity is optional and mailboxes bite.',
  icon: <Mail className="w-12 h-12" data-id="element-20" />,
  color: 'bg-brand-pink',
  rotate: '-rotate-2'
}, {
  id: 3,
  title: 'Neon Cabbage Saga',
  price: '€19.99',
  desc: 'Vegetable-based rhythm game with existential undertones and synthwave beats.',
  icon: <Zap className="w-12 h-12" data-id="element-21" />,
  color: 'bg-brand-purple',
  rotate: 'rotate-2'
}, {
  id: 4,
  title: 'Midnight Accordion',
  price: '€12.99',
  desc: 'Solve noir mysteries using only the emotional power of accordion music.',
  icon: <Music className="w-12 h-12" data-id="element-22" />,
  color: 'bg-brand-yellow',
  rotate: '-rotate-1'
}];
export function FeaturedGames() {
  return <section className="py-24 bg-brand-offwhite relative" data-id="element-23">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#1E1B4B 1px, transparent 1px)',
      backgroundSize: '20px 20px'
    }} data-id="element-24"></div>

      <div className="container mx-auto px-4 max-w-7xl relative z-10" data-id="element-25">
        <div className="text-center mb-20" data-id="element-26">
          <h2 className="text-5xl md:text-6xl font-display font-black text-brand-navy mb-4" data-id="element-27">
            This Week's{' '}
            <span className="text-brand-purple bg-brand-lime px-2 transform -skew-x-12 inline-block" data-id="element-28">
              Peculiar Picks
            </span>
          </h2>
          <p className="text-xl text-gray-600 font-body max-w-2xl mx-auto" data-id="element-29">
            Fresh from the weirdest corners of the internet.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-30">
          {games.map((game, idx) => <motion.div key={game.id} initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} whileHover={{
          y: -10,
          scale: 1.02
        }} className={`group relative flex flex-col h-full bg-white border-4 border-brand-navy p-6 shadow-quirky hover:shadow-quirky-lg transition-all duration-300 ${game.rotate}`} data-id="element-31">
              <div className={`absolute -top-6 left-1/2 -translate-x-1/2 w-16 h-16 ${game.color} border-4 border-brand-navy flex items-center justify-center rounded-full shadow-sm z-10 group-hover:rotate-12 transition-transform`} data-id="element-32">
                {game.icon}
              </div>

              <div className="mt-8 flex-1 text-center" data-id="element-33">
                <h3 className="text-2xl font-display font-bold text-brand-navy mb-2 leading-tight" data-id="element-34">
                  {game.title}
                </h3>
                <div className="inline-block bg-brand-navy text-white px-3 py-1 font-mono text-sm mb-4 transform -rotate-2" data-id="element-35">
                  {game.price}
                </div>
                <p className="text-gray-600 font-body leading-relaxed mb-6" data-id="element-36">
                  {game.desc}
                </p>
              </div>

              <Button variant="outline" className="w-full mt-auto group-hover:bg-brand-yellow group-hover:text-brand-navy" data-id="element-37">
                View Oddity
              </Button>
            </motion.div>)}
        </div>

        <div className="text-center mt-16" data-id="element-38">
          <Button size="lg" variant="primary" data-id="element-39">
            Browse All Curiosities
          </Button>
        </div>
      </div>
    </section>;
}